export default class SegcontrolController {
  constructor($attrs, $element) {
    'ngInject'
    this._$attrs = $attrs
    this._$element = $element
  }

  /**
   * Get and set the model value. This is behind a getter and setter so that we can use either the
   * ngModel value from the parent vd-segcontrol-group, or the legacy model binding.
   *
   * @readonly
   * @property model
   * @type {String}
   */
  get model() {
    return this.vdSegcontrolGroup
      ? this.vdSegcontrolGroup.ngModelCtrl.$viewValue
      : this._model
  }

  set model(value) {
    if (this.vdSegcontrolGroup) {
      this.vdSegcontrolGroup.ngModelCtrl.$viewValue = value
    } else {
      this._model = value
    }
  }

  $postLink() {
    let classes = 'vd-segcontrol'
    if (this._$attrs.modifier === 'panel') {
      classes += ' vd-segcontrol--panel'
    }
    this._$element.addClass(classes)
  }
}
